import React from 'react'

function CobroPersuasivoScreen() {
  return (
    <div>CobroPersuasivoScreen</div>
  )
}

export default CobroPersuasivoScreen